import { render, staticRenderFns } from "./goodsInquiryCreate.vue?vue&type=template&id=66621c6e&"
import script from "./goodsInquiryCreate.vue?vue&type=script&lang=js&"
export * from "./goodsInquiryCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports